import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormField } from '../../redux/types';
import DollarInputFieldWithEarnings, {
  DollarInputWithEarningsProps,
} from '../base/DollarInputField/presets/DollarInputFieldWithEarnings';
import { useTurnOffSaleOptionCallback } from '../hooks';

interface Props extends Pick<DollarInputWithEarningsProps, 'isResale' | 'className'> {}

const FixedPriceDollarInput: React.FC<Props> = props => {
  const { t } = useTranslation();
  const turnOffSaleOption = useTurnOffSaleOptionCallback();
  const { trigger, setValue, watch } = useFormContext();
  const currentValues = watch();

  return (
    <DollarInputFieldWithEarnings
      name="purchase_price"
      label={t('sellerModal.create.purchase_price.label')}
      productType="adopt_fixed"
      isRequired={currentValues.sell_as_fixed}
      onChange={newValue => {
        newValue && trigger('purchase_price');
        if (newValue && !currentValues.sell_as_fixed) {
          setValue('sell_as_fixed', true);
        } else if (!newValue && currentValues.sell_as_fixed) {
          turnOffSaleOption(FormField.SellAsFixed);
        }
        if (newValue && currentValues.sell_as_offer) {
          trigger(FormField.Offer);
        }
      }}
      noBottomSpacing
      {...props}
    />
  );
};

FixedPriceDollarInput.displayName = 'FixedPriceDollarInput';

export default FixedPriceDollarInput;
